import React, { ReactNode } from 'react';

import { PlainLayout } from '@/component/layout/PlainLayout/PlainLayout';

import * as styles from './mobileFirstAppLayout.css';

interface Props {
  children: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
}

export const MobileFirstAppLayout: React.FC<Props> = ({ children, header, footer }: Props) => (
  <PlainLayout>
    {header && <>{header}</>}
    <div className={styles.mobileFirstAppLayout}>{children}</div>
    {footer && <>{footer}</>}
  </PlainLayout>
);
